import { lazy } from "react";
import RouteGuard from "../routerPermission";
import { useNavigate, useParams } from "react-router-dom";

const Product = lazy(() => import("@/widgets/product-management/product"));
const ProductDetail = lazy(() => import("@/widgets/product-management/ProductDetail"));
const ChooseCategory = lazy(() => import("@/widgets/product-management/ChooseCategory"));
const ChooseSubCategory = lazy(() => import("@/widgets/product-management/ChooseSubCategory"));
const AddProductDetail = lazy(() => import("@/widgets/product-management/AddProduct"));
const AddProductWizard = lazy(() => import("@/widgets/product-management/wizard/AddProductWizard"));
const BulkProductImportPage = lazy(() => import("@/widgets/product-management/bulk-import/BulkProductImportPage"));

function AddProductWizardWithNavigation() {
  const navigate = useNavigate();
  const params = useParams();

  const handleBack = () => {
    const storeId = params.storeId;
    if (storeId) {
      navigate(`/store/${storeId}/products`);
    } else {
      navigate("/admin/products");
    }
  };

  return <AddProductWizard onBack={handleBack} />;
}

const productRoute = {
  path: "products",
  children: [
    {
      path: "",
      element: (
        <RouteGuard resource="product" action="read">
          <Product />
        </RouteGuard>
      ),
    },
    {
      path: ":productId",
      element: (
        <RouteGuard resource="product" action="read">
          <ProductDetail />
        </RouteGuard>
      ),
    },
    {
      path: "preview",
      element: (
        <RouteGuard resource="product" action="read">
          <ProductDetail />
        </RouteGuard>
      ),
    },
    {
      path: "edit/:productId",
      children: [
        {
          path: "",
          element: (
            <RouteGuard resource="product" action="update">
              <AddProductDetail />
            </RouteGuard>
          ),
        },
        {
          path: "preview",
          element: <ProductDetail />,
        },
      ],
    },
    {
      path: "bulk-import",
      element: (
        <RouteGuard resource="product" action="create">
          <BulkProductImportPage />
        </RouteGuard>
      ),
    },
    {
      path: "add-new-product",
      element: (
        <RouteGuard resource="product" action="create">
          <AddProductWizardWithNavigation />
        </RouteGuard>
      ),
    },
    {
      path: "add-new-product/:productId",
      element: (
        <RouteGuard resource="product" action="update">
          <AddProductWizardWithNavigation />
        </RouteGuard>
      ),
    },
    {
      path: "choose-category",
      children: [
        {
          path: "",
          element: <ChooseCategory />,
        },
        {
          path: ":categoryId",
          children: [
            {
              path: "",
              element: <ChooseSubCategory />,
            },
            {
              path: "add-product",
              children: [
                {
                  path: "",
                  element: (
                    <RouteGuard resource="product" action="create">
                      <AddProductDetail />
                    </RouteGuard>
                  ),
                },
                {
                  path: "preview",
                  element: (
                    <RouteGuard resource="product" action="read">
                      <ProductDetail />
                    </RouteGuard>
                  ),
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default productRoute;
